import { Box, Typography } from "@mui/joy";
import type { ReactNode } from "react";
import {
    MATERIAL_ROW,
    materialNestedGroupSx,
    materialSubgroupBandSx,
    materialRowDividerSx,
    materialRowTopDividerSx,
} from "./materialRowLayout";

export function MaterialGroupBlock({
    title,
    subtitle,
    children,
}: {
    title: string;
    subtitle?: string;
    showGrip?: boolean;
    children: ReactNode;
}) {
    return (
        <Box sx={materialNestedGroupSx}>
            <Box
                sx={{
                    px: MATERIAL_ROW.nestedPx,
                    py: 1,
                    ...materialRowDividerSx,
                    bgcolor: "background.level1",
                }}
            >
                <Typography level="body-sm">{title}</Typography>
                {subtitle && (
                    <Typography level="body-xs" color="neutral" sx={{ mt: 0.25 }}>
                        {subtitle}
                    </Typography>
                )}
            </Box>
            <Box>{children}</Box>
        </Box>
    );
}

export function MaterialSubgroupBlock({
    title,
    children,
}: {
    title: string;
    children: ReactNode;
}) {
    return (
        <Box
            sx={{
                "&:not(:first-of-type)": materialRowTopDividerSx,
            }}
        >
            <Box sx={materialSubgroupBandSx}>
                <Typography
                    level="body-xs"
                    sx={{ letterSpacing: "0.02em" }}
                >
                    Size:{" "}
                    <Typography component="span" level="body-xs">
                        {title}
                    </Typography>
                </Typography>
            </Box>
            {children}
        </Box>
    );
}
